module.exports = {"nav":{"langChange":"Byt språk","lang":"Språk","translate":"Översätt"}};